import client from 'enrollment-platform/api/eps.client'
import { AxiosResponse } from 'axios'

export interface PayrollDownloadUrl {
  effectiveDate: string
  downloadUrl: string
}

export interface PayrollDownloadUrlsResponse {
  downloadUrls: PayrollDownloadUrl[]
}

const PAYROLL_API_URL = '/api/v1/payroll/oe/deduction'

export async function fetchPayrollDownloadUrls(
  customerId: string
): Promise<PayrollDownloadUrlsResponse> {
  const response: AxiosResponse<PayrollDownloadUrlsResponse> = await client.get(
    `${PAYROLL_API_URL}/customer/${customerId}/download-urls`
  )

  return response.data
}

export interface PayrollCustomReportTemplate {
  name: string
  value: string
}

export interface PayrollCustomReportTemplatesResponse {
  templates: PayrollCustomReportTemplate[]
}

const PAYROLL_CUSTOM_REPORT_API_URL = '/api/v1/payroll/custom-report'

export async function fetchPayrollCustomReportTemplates(
  clientPublicKey: string
): Promise<PayrollCustomReportTemplatesResponse> {
  const response: AxiosResponse<PayrollCustomReportTemplatesResponse> =
    await client.get(`${PAYROLL_CUSTOM_REPORT_API_URL}/templates`, {
      params: { clientPublicKey },
    })

  return response.data
}

export interface CustomPayrollGeneratedFile {
  templateName: string
  filename: string
  startDate: string
  endDate: string
  createdAt: string
  downloadUrl: string
}

export interface CustomPayrollGeneratedHistoryResponse {
  isDisplayEnabled: boolean
  files: CustomPayrollGeneratedFile[]
}

export async function fetchCustomPayrollGeneratedHistory(
  clientPublicKey: string
): Promise<CustomPayrollGeneratedHistoryResponse> {
  const response: AxiosResponse<CustomPayrollGeneratedHistoryResponse> =
    await client.get(`${PAYROLL_CUSTOM_REPORT_API_URL}/generated-history`, {
      params: { clientPublicKey },
    })

  return response.data
}
